export default function removeDuplicatesArrayObj(arr, keyProps = []) {
  if (keyProps.length) {
    const kvArray = arr.map(entry => {
      const key = keyProps.map(k => entry[k]).join('|');
      return [key, entry];
    });
    const map = new Map(kvArray);
    return Array.from(map.values());
  } else { return [...new Map(arr.map(v => [JSON.stringify(v), v])).values()]; }
}
